import { useTranslation } from 'react-i18next'
import { useApiGetDirectorYearlyTrajectoriesGmv } from 'core/api/trajectory-photo/useApiGetDirectorYearlyTrajectoriesGmv'
import StoreTrajectoryGmvCard from './store-trajectory-gmv-card'
import WidgetLoading from 'components/common/cards/widget-loading'
import { useContext, useEffect } from 'react'
import { StoreTrajectoryContext } from './state/store-trajectory-context'

const StoreTrajectories = () => {
  const { t } = useTranslation()
  const { storeId, store, setTargetYear } = useContext(StoreTrajectoryContext)

  useEffect(() => {
    setTargetYear(null)
  }, [setTargetYear])

  const { data, isLoading } = useApiGetDirectorYearlyTrajectoriesGmv(storeId, !!storeId)
  const currency = store?.currency ?? ''
  const currentYear = new Date().getFullYear()

  if (isLoading) {
    return (
      <WidgetLoading
        className="mg-store-trajectories mg-store-trajectories-loading"
        dataTestId="store-trajectories-loading"
        skeletonCount={3}
      />
    )
  }

  return (
    <div data-testid="store-trajectories" className="mg-store-trajectories">
      <div className="mg-store-trajectories-header">
        <div data-testid="store-trajectories-title" className="mg-store-trajectories-header-title vp-title-m">
          {t('general.trajectory.store.title')}
        </div>
      </div>
      <div className="mg-store-trajectories-body">
        <div className="mg-store-trajectories-cards">
          {data.directorYearlyTrajectories
            .sort((a, b) => a.year - b.year)
            .map(yearlyValues => (
              <StoreTrajectoryGmvCard
                key={yearlyValues.year}
                yearlyValues={yearlyValues}
                storeId={storeId}
                currency={currency}
              />
            ))}
        </div>
        {data.directorYearlyTrajectories.some(
          yearlyValues => yearlyValues.progression && yearlyValues.year > currentYear
        ) && (
          <div data-testid="store-trajectories-notice" className="mg-store-trajectories-notice vp-caption">
            * {t('general.trajectory.store.progression-notice')}
          </div>
        )}
      </div>
    </div>
  )
}

export default StoreTrajectories
